import styled from 'styled-components';

export default styled.div`
  && {
    .ant-form-item {
      margin-bottom: 0px;
    }
    .section {
      padding: 30px 65px;
      .※ {
        color: rgba(255, 0, 0, 1);
        height: 18px;
        width: 12px;
        margin-right: 4px;
      }
      .input-form {
        background-color: rgba(238, 238, 238, 1);
        padding: 40px 30px;
        .btn-search {
          background-color: #ff8a00;
          color: white;
          margin-left: 5px;
          border: none;
          border-radius: 5px;
        }
      }
      .submit {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 30px;
        margin-bottom: 30px;
        .text {
          text-align: center;
          margin-bottom: 20px;
        }
        .btn {
          width: 240px;
          height: 60px;
        }
      }
    }
    .pl-5 {
      padding-left: 5%;
    }
    .mt-28 {
      margin-top: 28px;
    }
    .mb-29 {
      margin-bottom: 29px;
    }
    .mb-7 {
      margin-bottom: 7px;
    }
    .pr {
      position: relative;
      padding-left: 20px;
    }
    .flex-align {
      display: flex;
      align-items: center;
      margin-bottom: 19px;
    }
    .bold {
      font-weight: bold;
    }
  }
`;
